import { Box, Typography } from "@mui/material";
import Items from "../../components/Items";

interface SummaryStepProps {
  subtotal: number;
  deliveryFee: string;
  credit: number;
  total: number;
}

const SummaryStep: React.FC<SummaryStepProps> = ({
  subtotal,
  deliveryFee,
  credit,
  total,
}) => {
  return (
    <Box>
      <Typography variant="h4" component="h2" gutterBottom>
        Resumo do pedido
      </Typography>
      <Items />
      <Typography sx={{ textAlign: "right" }} variant="h6" component="div">
        Subtotal: R$ {subtotal.toFixed(2)}
      </Typography>
      {parseFloat(deliveryFee) > 0 && (
        <Typography sx={{ textAlign: "right" }} variant="h6" component="div">
          Frete: R$ {deliveryFee}
        </Typography>
      )}
      {credit > 0 && (
        <Typography sx={{ textAlign: "right" }} variant="h6" component="div">
          Crédito: R$ {credit}
        </Typography>
      )}
      <Typography sx={{ textAlign: "right" }} variant="h5" component="div">
        Total: R$ {total.toFixed(2)}
      </Typography>
    </Box>
  );
};

export default SummaryStep;
